// src/pages/ReviewPage.tsx

import { useEffect, useState, FormEvent } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { fetchVocabsForReviewByTopicId, submitReview } from '../api/api';
import { ReviewItem, VocabularyWord } from '../types';
import ScoreCircle from '../components/ScoreCircle';
import EmptyState from '../components/EmptyState';

function ReviewPage() {
  const { topicId } = useParams<{ topicId: string }>();
  const [reviewWords, setReviewWords] = useState<ReviewItem[]>([]);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [userAnswer, setUserAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [score, setScore] = useState(0);
  const [isFinished, setIsFinished] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (topicId) {
      const getWords = async () => {
        try {
          const reviewWords = await fetchVocabsForReviewByTopicId(topicId, '1');
          if (reviewWords) {
            setScore(reviewWords[0].score);
            reviewWords.forEach(item => {
              item.userDefinition = "";
              item.feedback = "";
            });
            setReviewWords(reviewWords);
          }
        } catch (error) {
          console.error("Failed to fetch review words:", error);
          setReviewWords([]); // Gán thành mảng rỗng nếu có lỗi
        } finally {
          setLoading(false);
        }
      };
      getWords();
    }
  }, [topicId]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const currentWord = reviewWords[currentWordIndex];

    const result = await submitReview(currentWord.vocabulary.id, userAnswer, 0);
    setFeedback(result.feedback);
    setScore(result.score);
    reviewWords[currentWordIndex].userDefinition = userAnswer;
    reviewWords[currentWordIndex].feedback = result.feedback;
    reviewWords[currentWordIndex].score = result.score;
    setReviewWords(reviewWords);
    console.log("reviewWords", reviewWords);
  };

  const handleNext = () => {
    console.log("reviewWords", reviewWords);
    setCurrentWordIndex(prev => (prev + 1) % reviewWords.length);
    setScore(reviewWords[(currentWordIndex + 1) % reviewWords.length].score);
    setFeedback(reviewWords[(currentWordIndex + 1) % reviewWords.length].feedback);
    setUserAnswer(reviewWords[(currentWordIndex + 1) % reviewWords.length].userDefinition);
  };

  const handlePrev = () => {
    console.log("currentWordIndex", currentWordIndex);
    setCurrentWordIndex(prev => (prev - 1 + reviewWords.length) % reviewWords.length);
    setScore(reviewWords[(currentWordIndex - 1 + reviewWords.length) % reviewWords.length].score);
    setFeedback(reviewWords[(currentWordIndex - 1 + reviewWords.length) % reviewWords.length].feedback);
    setUserAnswer(reviewWords[(currentWordIndex - 1 + reviewWords.length) % reviewWords.length].userDefinition);
  };

  if (loading) return <div>Loading test...</div>;
  if (!reviewWords || reviewWords.length === 0) {
    return (
       <EmptyState
        title="Nothing to Review"
        message="There are no vocabulary words in this topic to review right now."
        action={
          <button onClick={() => navigate(-1)} className="btn btn-primary">
            ‹ Go Back
          </button>
        }
      />
    );
  }

  if (isFinished) {
    return (
      <div className="quiz-container">
        <h2>Finished!</h2>
        <p>Your score: {score} / {reviewWords.length}</p>
        <Link to="/" className="btn btn-primary">Do another one</Link>
      </div>
    );
  }

  const currentWord = reviewWords[currentWordIndex];

  return (
    <div className="quiz-container glass-effect">
      {/* <button onClick={() => navigate(-1)} className="btn-back">
        ‹ Back
      </button> */}
      <div className="page-header">
        <button onClick={() => navigate(-1)} className="btn-back">‹ Back</button>
        <div className="topic-title">
          <h2>Vocabulary Test</h2>
          <span>Question {currentWordIndex + 1} of {reviewWords.length}</span>
        </div>
        
      </div>
      {/* Thanh tiến trình */}
      <div className="progress-bar-container">
        <div
          className="progress-bar"
          style={{ width: `${(currentWordIndex + 1) / reviewWords.length * 100}%` }}
        ></div>
      </div>

      <p className="quiz-word">{currentWord.vocabulary.word} ({currentWord.vocabulary.type})</p>

      <form onSubmit={handleSubmit}>
        <textarea
          value={userAnswer}
          onChange={(e) => setUserAnswer(e.target.value)}
          placeholder="Type the English definition..."
          disabled={!!feedback}
          rows={3} // Gợi ý số dòng hiển thị ban đầu
        ></textarea>
        <button type="submit" className="btn btn-submit" disabled={!!feedback}>
          Check
        </button>
      </form>

      {/* Khu vực trạng thái: chứa feedback và điểm số */}
      <div className="quiz-status">
        {feedback && (
          <p className={`feedback ${score >= 3 ? 'correct' : 'incorrect'}`}>
            {feedback}
          </p>
        )}
        <p className="score">Score: {score}/5</p>
        {/* <ScoreCircle score={score} /> */}
      </div>

      <footer className="page-footer">
        <button onClick={handlePrev} className="btn btn-nav">‹ Previous</button>
        <button onClick={handleNext} className="btn btn-nav">Next ›</button>
      </footer>
    </div>
  );
}

export default ReviewPage;